export default "__VITE_ASSET__BjIxIpyp__"